import { accountIdentity, identityAccountId, RoomEntity } from "@common/domain";
import { accountEmail } from "./accountEmail";
import { accountFirstName } from "./accountFirstName";
import { accountLastName } from "./accountLastName";
import { accountUsername } from "./accountUsername";

export const accountEntityRaw = {
  type: "object",
  required: ["id", "identity", "defaultRoom"],
  properties: {
    id: identityAccountId,
    identity: accountIdentity,
    username: accountUsername,
    email: accountEmail,
    firstName: accountFirstName,
    lastName: accountLastName,
    defaultRoom: RoomEntity.schema()
  },
  additionalProperties: false
};
